import type { RankingItem } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { textToRtValue } from '@vedalib/rich-text'
import * as R from 'ramda'

import ControlItem from 'components/Editor/cource/layout/controls/ControlItem'
import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import TestElementChangeStateActions from 'components/Editor/cource/layout/controls/ElementControls/TestElementChangeState'
import Separator from 'components/Editor/cource/layout/controls/Separator'
import { Tooltip } from 'components/uiKit/Dropdown'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import type { TestRankingStateType, TestRankingEditorActionsType } from './testRankingTypes'

const genItem = (id: string): RankingItem => ({
  label: textToRtValue(''),
  value: id,
  points: 1,
})

const ACTIONS = {
  ADD_ITEM: {
    icon: 'otherAdd',
    label: t('uiKit.tooltip.addAnswer'),
    value: 'ADD_ITEM',
  },
} as const

const TestRankingEditorActions: TestRankingEditorActionsType = ({
  element: { value },
  onChange,
  setAppMode,
  customMode,
  mode,
  setState,
  state,
}) => {
  const isFill = mode.editorMode === AppMode.fill || customMode?.editorMode === AppMode.fill
  const isPro = mode.editorMode === AppMode.pro

  const addItem = () =>
    onChange(R.assoc('items', R.append(genItem(generateId()), value.items), value))

  return (
    <>
      {isPro && <EditableProMode customMode={customMode} mode={mode} setAppMode={setAppMode} />}
      {isPro && isFill && <Separator />}
      {isFill && (
        <Tooltip overlay={t('uiKit.tooltip.addAnswer')}>
          <ControlItem handler={addItem} option={ACTIONS.ADD_ITEM} />
        </Tooltip>
      )}
      <TestElementChangeStateActions<TestRankingStateType>
        setState={setState}
        state={state}
        value={value}
      />
    </>
  )
}

export default TestRankingEditorActions
